import React from "react";
import { Album } from "../../model/domain/album";
import TaskAlbums from "../../ws/TaskAlbums";
import { LoadingView } from "@cuatroochenta/co-admin-react-library";
import AlbumsView from "./AlbumsView";
import { User } from "../../model/domain/user";
import { CustomResponse } from "../../model/data/common";

interface State {
    albums: Album[]
    loading: boolean
    error?: Error
    user: User
}

class AlbumContainer extends React.Component<{}, State> {
    public state: State = {
        albums: [],
        loading: false,
        user: {
            success: false,
            code: 0,
            data: {
                id: 0,
                fullName: "",
                email: "",
                address: null,
                city: null,
                county: null,
                phone: null,
                postalCode: null,
                userName: "",
                profileColor: undefined,
                roles: [],
                ddbbResiplusId: 0,
                createNewsPermission: false,
                profilePicturePath: null
            }
        }
    }

    componentDidMount() {
        this.setState({ loading: true });
        Promise.all([
            this.fetchUser(),
            this.fetchAlbums(),
        ])
        .then(() => {
            this.setState({ loading: false });
        });
    }

    private fetchUser = () => {
        return new TaskAlbums().getUser()
            .then((response: User) => {
                if (response.success) {
                    this.setState({ user: response });
                } else {
                    this.setState({
                        error: new Error('Error al obtener el usuario')
                    });
                }
            })
            .catch(error => {
                console.error('Error al obtener el usuario:', error);
                this.setState({ error });
            });
    }

    private fetchAlbums = () => {
        return new TaskAlbums().getAlbums()
            .then((response: CustomResponse<Album[]>) => {
                if (response.success && Array.isArray(response.data)) {
                    this.setState({ albums: response.data });
                } else {
                    console.error('No se encontraron álbumes en la respuesta');
                }
            })
            .catch(error => {
                console.error('Error al obtener los álbumes:', error);
            });
    };

    private updateViewData = async () => {
        const scrollPosition = window.scrollY;
        await this.fetchAlbums()
        window.scrollTo(0, scrollPosition);
    }

    public render() {
        const { albums, loading, error, user } = this.state

        if (loading && albums.length === 0) {
            return <LoadingView loading={loading} />
        }

        if (error) {
            return <div>Error: {error.message}</div>
        }

        return (
            <AlbumsView 
                albums={albums}
                user={user}
                updateView={this.updateViewData}
            />
        )
    }

}

export default AlbumContainer;